import React from "react";

import ReactDOM from "react-dom/client";

import App from "./App";

import "./index.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { initTrackers } from "@/tracking";

import "./i18n";

initTrackers();

const queryClient = new QueryClient({
  defaultOptions: { queries: { throwOnError: true } },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
